import { ChainId } from '../../sdk/chainId'
import { Currency } from '../../sdk/entities/currency'
import { ALL_CHAIN_IDS } from '../chains/index'
import { getChain } from '../active'

export function buildNativeMap(): Partial<Record<ChainId, Currency>> {
  const map: Partial<Record<ChainId, Currency>> = {}
  for (const chainId of ALL_CHAIN_IDS) {
    const chain = getChain(chainId)
    if (!chain.configured) continue
    const { nativeCurrency } = chain
    map[chainId] = new Currency(
      nativeCurrency.decimals,
      nativeCurrency.symbol,
      nativeCurrency.name,
    )
  }
  return map
}
